import config from '../config';
import axios from 'axios';
const baseUrl = config.RDPMS_API_URLS;
const MBaseUrl = config.MOBIUS_API_URL;

const handleAPIResponse = async (result) => {
    const response = result.data;
    try {
        if (response.isSucess === true) {
            return response.response;
        } else if (response.isSucess === false) {
            return response.response;
        } else {
            return response.response;
        }
    } catch (error) {
        console.error(`Error in API call to :`, error);
        return null;
    }
};

// Get User Profile
export async function getUserProfile(id) {
    return await axios.post(baseUrl + `/user/${id}`).then((response) => handleAPIResponse(response));
}

// Create User
export async function createUser(data) {
    return await axios.post(baseUrl + '/users/create', data).then((response) => handleAPIResponse(response));
}

// Update User
export async function updateUser(id, value) {
    // console.log('UPDATE API CALLED WITH ID:', id);
    return axios.post(`${baseUrl}/users/update/${id}`, value).then((response) => handleAPIResponse(response));
}

// Delete User
export async function deleteUser(id) {
    return await axios.post(baseUrl + `/users/delete/${id}`).then((response) => handleAPIResponse(response));
}

export async function checkUserIdAPI(id) {
    return await axios.post(baseUrl + '/users/check/id', id).then((response) => handleAPIResponse(response));
}

// Get All Users (Pagination)
export async function getAllUsers(data) {
    return await axios.post(baseUrl + '/allusers', data).then((response) => handleAPIResponse(response));
}

export async function changePassword(value) {
    return await axios
        .post(baseUrl + '/user/change/password/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function updateProfile(value) {
    return await axios
        .post(baseUrl + '/user/change/profile/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function verifyOtpAPI(value) {
    return await axios.post(baseUrl + '/user/verify/otp', value).then((response) => handleAPIResponse(response));
}

//All API
export async function getDcCircuitAPI(value) {
    return await axios.post(baseUrl + '/dccircuit', value).then((response) => handleAPIResponse(response));
}

export async function getDcCircuitExportData(value) {
    return await axios.post(baseUrl + '/dccircuit/export', value).then((response) => handleAPIResponse(response));
}
export async function getDcCircuitArchieveAPI(value) {
    return await axios.post(baseUrl + '/archieve/dccircuit', value).then((response) => handleAPIResponse(response));
}

export async function getDcCircuitArchieveAlertAPI(value) {
    return await axios
        .post(baseUrl + '/archieve/dccircuit/alert', value)
        .then((response) => handleAPIResponse(response));
}

export async function getFeedEndCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/dccircuit/feedendcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getFeedEndVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/dccircuit/feedendvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getRelayEndVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/dccircuit/relayendvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getRelayEndCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/dccircuit/relayendcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getChargerCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/dccircuit/chargercurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getTPRGraphAPI(value) {
    return await axios.post(baseUrl + '/dccircuit/tpr', value).then((response) => handleAPIResponse(response));
}

export async function getChargerPotentialFreeContactAPI(value) {
    return await axios
        .post(baseUrl + '/dccircuit/chargerpotentialfreecontact', value)
        .then((response) => handleAPIResponse(response));
}

export async function getIPSOverviewAPI(value) {
    return await axios.post(baseUrl + '/ips', value).then((response) => handleAPIResponse(response));
}

export async function getIPSOverviewExportData(value) {
    return await axios.post(baseUrl + '/ips/export', value).then((response) => handleAPIResponse(response));
}

export async function getIPSArchieveAlertAPI(value) {
    return await axios.post(baseUrl + '/archieve/ips/alert', value).then((response) => handleAPIResponse(response));
}

export async function getInputVoltageGraphAPI(value) {
    return await axios.post(baseUrl + '/ips/inputvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getInputCurrentGraphAPI(value) {
    return await axios.post(baseUrl + '/ips/inputcurrent', value).then((response) => handleAPIResponse(response));
}

export async function getBatteryOutputVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/ips/batteryoutputvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getBatteryChargingCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/ips/batterychargingcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getDcConverterOutputVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/ips/dcconverteroutputvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getDcConverterOutputCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/ips/dcconverteroutputcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getInverterInputVoltageAPI(value) {
    return await axios
        .post(baseUrl + '/ips/inverterinputvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getInverterOutputCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/ips/inverteroutputcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getInverterOutputVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/ips/inverteroutputvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getFRBCOutputVoltageGraphAPI(value) {
    return await axios.post(baseUrl + '/ips/frbcoutputvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getHealthOfIPSModulesThroughPFCGraphAPI(value) {
    return await axios
        .post(baseUrl + '/ips/healthofipsmodulesthroughpfc', value)
        .then((response) => handleAPIResponse(response));
}

export async function getAvailabilityOfStandByPowerSupplyAPI(value) {
    return await axios
        .post(baseUrl + '/ips/availabilityofstandbypowersupply', value)
        .then((response) => handleAPIResponse(response));
}

export async function getIPSOverviewArchieveAPI(value) {
    return await axios.post(baseUrl + '/archieve/ips', value).then((response) => handleAPIResponse(response));
}

export async function getIPSOverviewArchieveAlertAPI(value) {
    return await axios.post(baseUrl + '/archieve/ips/alert', value).then((response) => handleAPIResponse(response));
}

export async function getPointMachineOverviewAPI(value) {
    return await axios.post(baseUrl + '/pointmachine', value).then((response) => handleAPIResponse(response));
}

export async function getPointMachineOverviewExportData(value) {
    return await axios.post(baseUrl + '/pointmachine/export', value).then((response) => handleAPIResponse(response));
}

export async function getForwardOperatingCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/pointmachine/forwardoperatingcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getReverseOperatingCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/pointmachine/reverseoperatingcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getForwardOperatingVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/pointmachine/forwardoperatingvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getReverseOperatingVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/pointmachine/reverseoperatingvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getTimeOfOperationGraphAPI(value) {
    return await axios
        .post(baseUrl + '/pointmachine/timeofoperation', value)
        .then((response) => handleAPIResponse(response));
}

export async function getPointPositionVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/pointmachine/pointposition', value)
        .then((response) => handleAPIResponse(response));
}

export async function getVibrationGraphAPI(value) {
    return await axios.post(baseUrl + '/pointmachine/vibration', value).then((response) => handleAPIResponse(response));
}

export async function getPointPositionRelayGraphAPI(value) {
    return await axios.post(baseUrl + '/pointmachine/relay', value).then((response) => handleAPIResponse(response));
}

export async function getPointMachineArchieveAlertAPI(value) {
    return await axios
        .post(baseUrl + '/archieve/pointmachine/alert', value)
        .then((response) => handleAPIResponse(response));
}

export async function getPointMachineOverviewArchieveAPI(value) {
    return await axios.post(baseUrl + '/archieve/pointmachine', value).then((response) => handleAPIResponse(response));
}

export async function getPointMachineOverviewArchieveAlertAPI(value) {
    return await axios
        .post(baseUrl + '/archieve/pointmachine/alert', value)
        .then((response) => handleAPIResponse(response));
}

export async function getBatteryChargerAPI(value) {
    return await axios.post(baseUrl + '/batterycharger', value).then((response) => handleAPIResponse(response));
}

export async function getBatteryChargerExportData(value) {
    return await axios.post(baseUrl + '/batterycharger/export', value).then((response) => handleAPIResponse(response));
}

export async function getChargerInputVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/batterycharger/chargerinputvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getChargerInputCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/batterycharger/chargerinputcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getChargerOutputVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/batterycharger/chargeroutputvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getChargerOutputCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/batterycharger/chargeroutputcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getChargerBatteryOutputVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/batterycharger/batteryoutputvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getChargerBatteryOutputCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/batterycharger/batteryoutputcurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getBatteryChargerArchieveAlertAPI(value) {
    return await axios
        .post(baseUrl + '/archieve/batterycharger/alert', value)
        .then((response) => handleAPIResponse(response));
}

export async function getbatteryChargerArchieveAPI(value) {
    return await axios
        .post(baseUrl + '/archieve/batterycharger', value)
        .then((response) => handleAPIResponse(response));
}

export async function getDashboardDcCircuitAPI(value) {
    return await axios.post(baseUrl + '/dashboard/dccircuit', value).then((response) => handleAPIResponse(response));
}

export async function getLastDcCircuitAPI() {
    return await axios.post(baseUrl + '/dashboard/dccircuit/dot').then((response) => handleAPIResponse(response));
}

export async function getDashboardPointMachineAPI(value) {
    return await axios.post(baseUrl + '/dashboard/pointmachine', value).then((response) => handleAPIResponse(response));
}

export async function getDashboardBatteryChargerAPI(value) {
    return await axios
        .post(baseUrl + '/dashboard/batterycharger', value)
        .then((response) => handleAPIResponse(response));
}

export async function getDashboardIPSAPI(value) {
    return await axios.post(baseUrl + '/dashboard/ips', value).then((response) => handleAPIResponse(response));
}

export async function getDashboardSignalAPI(value) {
    return await axios.post(baseUrl + '/dashboard/signal', value).then((response) => handleAPIResponse(response));
}

export async function getSignalAPI(value) {
    return await axios.post(baseUrl + '/signal', value).then((response) => handleAPIResponse(response));
}
export async function getSignalExportData(value) {
    return await axios.post(baseUrl + '/signal/export', value).then((response) => handleAPIResponse(response));
}

export async function getRedAcCurrentGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/redaccurrent', value).then((response) => handleAPIResponse(response));
}

export async function getRedAcVoltageGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/redacvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getGreenAcCurrentGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/greenaccurrent', value).then((response) => handleAPIResponse(response));
}

export async function getGreenAcVoltageGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/greenacvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getYellowAcCurrentGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/yellowaccurrent', value).then((response) => handleAPIResponse(response));
}

export async function getYellowAcVoltageGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/yellowacvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getOtherAcCurrentGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/otheraccurrent', value).then((response) => handleAPIResponse(response));
}

export async function getOtherAcVoltageGraphAPI(value) {
    return await axios.post(baseUrl + '/signal/otheracvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getSignalAlertAPI(value) {
    return await axios.post(baseUrl + '/archieve/signal/alert', value).then((response) => handleAPIResponse(response));
}

export async function getSignalArchieveAPI(value) {
    return await axios.post(baseUrl + '/archieve/signal', value).then((response) => handleAPIResponse(response));
}

export async function getSignalArchieveAlertAPI(value) {
    return await axios.post(baseUrl + '/archieve/signal/alert', value).then((response) => handleAPIResponse(response));
}

//add all master
// add dc circuit
export async function getMasterDcCircuitAPI(value) {
    return await axios.post(baseUrl + '/master/dccircuit', value).then((response) => handleAPIResponse(response));
}

export async function addDCCircuitAPI(value) {
    return await axios
        .post(baseUrl + '/master/dccircuit/create', value)
        .then((response) => handleAPIResponse(response));
}

export async function editDCCircuitAPI(value) {
    return await axios
        .post(baseUrl + '/master/dccircuit/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteDCCircuitAPI(id) {
    return await axios.post(baseUrl + '/master/dccircuit/delete/' + id).then((response) => handleAPIResponse(response));
}

// add all master
// add hassdac
export async function getMasterHassdacAPI(value) {
    return await axios.post(baseUrl + '/master/hassdac', value).then((response) => handleAPIResponse(response));
}

export async function addHassdacAPI(value) {
    return await axios.post(baseUrl + '/master/hassdac/create', value).then((response) => handleAPIResponse(response));
}

export async function editHassdacAPI(value) {
    return await axios
        .post(baseUrl + '/master/hassdac/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteHassdacAPI(id) {
    return await axios.post(baseUrl + '/master/hassdac/delete/' + id).then((response) => handleAPIResponse(response));
}

export async function getDashboardHASSDACAPI(value) {
    return await axios.post(baseUrl + '/dashboard/hassdac', value).then((response) => handleAPIResponse(response));
}

export async function getHassdacAPI(value) {
    return await axios.post(baseUrl + '/hassdac', value).then((response) => handleAPIResponse(response));
}

export async function getHassdacExportData(value) {
    return await axios.post(baseUrl + '/hassdac/export', value).then((response) => handleAPIResponse(response));
}
export async function getHassdacArchieveAPI(value) {
    return await axios.post(baseUrl + '/archieve/hassdac', value).then((response) => handleAPIResponse(response));
}

export async function getInputCurrentsGraphAPI(value) {
    return await axios.post(baseUrl + '/hassdac/inputcurrent', value).then((response) => handleAPIResponse(response));
}

export async function getInputVoltagesGraphAPI(value) {
    return await axios.post(baseUrl + '/hassdac/inputvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getVitalRelayVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/hassdac/vitalrelayvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getVitalRelayCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/hassdac/vitalrelaycurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getResetVoltageGraphAPI(value) {
    return await axios.post(baseUrl + '/hassdac/resetvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getHassdacArchieveAlertAPI(value) {
    return await axios.post(baseUrl + '/archieve/hassdac/alert', value).then((response) => handleAPIResponse(response));
}

// add point machine
export async function getMasterPointMachineAPI(value) {
    return await axios.post(baseUrl + '/master/pointmachine', value).then((response) => handleAPIResponse(response));
}

export async function addPointMachineAPI(value) {
    return await axios
        .post(baseUrl + '/master/pointmachine/create', value)
        .then((response) => handleAPIResponse(response));
}

export async function editPointMachineAPI(value) {
    return await axios
        .post(baseUrl + '/master/pointmachine/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deletePointMachineAPI(id) {
    return await axios
        .post(baseUrl + '/master/pointmachine/delete/' + id)
        .then((response) => handleAPIResponse(response));
}

// add batteries
export async function getMasterBatteriesAPI(value) {
    return await axios.post(baseUrl + '/master/batterycharger', value).then((response) => handleAPIResponse(response));
}

export async function addBatteriesAPI(value) {
    return await axios
        .post(baseUrl + '/master/batterycharger/create', value)
        .then((response) => handleAPIResponse(response));
}

export async function editBatteriesAPI(value) {
    return await axios
        .post(baseUrl + '/master/batterycharger/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteBatteriesAPI(id) {
    return await axios
        .post(baseUrl + '/master/batterycharger/delete/' + id)
        .then((response) => handleAPIResponse(response));
}

// add ips
export async function getMasterIPSAPI(value) {
    return await axios.post(baseUrl + '/master/ips', value).then((response) => handleAPIResponse(response));
}

export async function addIPSAPI(value) {
    return await axios.post(baseUrl + '/master/ips/create', value).then((response) => handleAPIResponse(response));
}

export async function editIPSAPI(value) {
    return await axios
        .post(baseUrl + '/master/ips/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteIPSAPI(id) {
    return await axios.post(baseUrl + '/master/ips/delete/' + id).then((response) => handleAPIResponse(response));
}

// add signal
export async function getMasterSignalAPI(value) {
    return await axios.post(baseUrl + '/master/signal', value).then((response) => handleAPIResponse(response));
}

export async function addSignalAPI(value) {
    return await axios.post(baseUrl + '/master/signal/create', value).then((response) => handleAPIResponse(response));
}

export async function editSignalAPI(value) {
    return await axios
        .post(baseUrl + '/master/signal/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteSignalAPI(id) {
    return await axios.post(baseUrl + '/master/signal/delete/' + id).then((response) => handleAPIResponse(response));
}

export async function getStationAPI(id) {
    return await axios.post(baseUrl + '/dashboard/station/' + id).then((response) => handleAPIResponse(response));
}

// add Station
export async function addStationAPI(value) {
    return await axios.post(baseUrl + '/station/create', value).then((response) => handleAPIResponse(response));
}

export async function editStationAPI(value) {
    return await axios
        .post(baseUrl + '/station/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteStationAPI(value) {
    return await axios.post(baseUrl + '/station/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllStationAPI(value) {
    return await axios.post(baseUrl + '/station', value).then((response) => handleAPIResponse(response));
}

export async function getStationNameAPI(value) {
    return await axios.post(baseUrl + '/stations/name', value).then((response) => handleAPIResponse(response));
}

export async function getUserStationAPI(id) {
    return await axios.post(baseUrl + '/user/station/' + id).then((response) => handleAPIResponse(response));
}
export async function getStationForUserAPI() {
    return await axios.post(baseUrl + '/allstation').then((response) => handleAPIResponse(response));
}
// Vendor
export async function addVendorAPI(value) {
    return await axios.post(baseUrl + '/vendor/create', value).then((response) => handleAPIResponse(response));
}

export async function editVendorAPI(value) {
    return await axios
        .post(baseUrl + '/vendor/update/' + value._id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteVendorAPI(value) {
    return await axios.post(baseUrl + '/vendor/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllVendorsAPI() {
    return await axios.post(baseUrl + '/vendor').then((response) => handleAPIResponse(response));
}
export async function getAllVendorsPageAPI(value) {
    return await axios.post(baseUrl + '/allvendor', value).then((response) => handleAPIResponse(response));
}

// Zone
export async function addZoneAPI(value) {
    return await axios.post(baseUrl + '/zone/create', value).then((response) => handleAPIResponse(response));
}

export async function editZoneAPI(value) {
    return await axios
        .post(baseUrl + '/zone/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteZoneAPI(value) {
    return await axios.post(baseUrl + '/zone/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllZonesAPI() {
    return await axios.post(baseUrl + '/zone').then((response) => handleAPIResponse(response));
}
export async function getAllZonesPageAPI(value) {
    return await axios.post(baseUrl + '/allzone', value).then((response) => handleAPIResponse(response));
}

export async function getZoneAPI(id) {
    return await axios.post(baseUrl + '/zone/' + id).then((response) => handleAPIResponse(response));
}

// Division
export async function addDivisionAPI(value) {
    return await axios.post(baseUrl + '/division/create', value).then((response) => handleAPIResponse(response));
}

export async function editDivisionAPI(value) {
    return await axios
        .post(baseUrl + '/division/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteDivisionAPI(value) {
    return await axios.post(baseUrl + '/division/delete/' + value).then((response) => handleAPIResponse(response));
}

export async function getAllDivisionsAPI(id) {
    return await axios.post(baseUrl + '/division', { id }).then((response) => handleAPIResponse(response));
}
export async function getAllDivisionsZoneAPI(value) {
    return await axios.post(baseUrl + '/alldivision', value).then((response) => handleAPIResponse(response));
}

export async function getDivisionAPI(id) {
    return await axios.post(baseUrl + '/division/' + id).then((response) => handleAPIResponse(response));
}

export async function getReportAPI(value) {
    return await axios.post(baseUrl + '/reports', value).then((response) => handleAPIResponse(response));
}

export async function getDeviceAPI(value) {
    return await axios.post(baseUrl + '/device', value).then((response) => {
        let deviceResponse = response.data;
        if (deviceResponse.isSucess === true) {
            return deviceResponse.response;
        } else if (deviceResponse.isSucess === false) {
            return deviceResponse.response;
        } else {
            return deviceResponse.response;
        }
    });
}

export async function getReportGraphAPI(value) {
    return await axios.post(baseUrl + '/reports/graph', value).then((response) => handleAPIResponse(response));
}

// notification

export async function getNotification(value) {
    return await axios.post(baseUrl + '/notification', value).then((response) => handleAPIResponse(response));
}

export async function getDeviceDataApi(value) {
    return await axios
        .post(baseUrl + '/notification/all/device', value)
        .then((response) => handleAPIResponse(response));
}

// add feedback
export async function addFeedback(values) {
    const formData = new FormData();
    const files = values.file;
    for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
    }

    formData.append('alert', values.alert);
    formData.append('archievesId', values.archievesId);
    formData.append('name', values.name);
    formData.append('descriptions', values.descriptions);
    formData.append('masterId', values.masterId);
    formData.append('stationId', values.stationId);
    formData.append('notificationId', values.notificationId);
    formData.append('maintainerDesignation', values.maintainerDesignation);
    formData.append('maintainerMobile', values.maintainerMobile);
    formData.append('maintainerName', values.maintainerName);
    formData.append('rectificationDateTime', values.rectificationDateTime);
    formData.append('causeCode', values.causeCode);

    return await axios.post(baseUrl + '/feedback/create', formData).then((response) => handleAPIResponse(response));
}

export async function addFeedbackComments(values) {
    return await axios.post(baseUrl + '/feedback/comments', values).then((response) => handleAPIResponse(response));
}

export async function getFeedback(value) {
    return await axios.post(baseUrl + '/feedback', value).then((response) => handleAPIResponse(response));
}

export async function registerDeviceMobius(value) {
    return await axios
        .post(MBaseUrl + '/device/register', value, {
            headers: {
                'Content-Type': 'application/json',
                'X-M2M-TY': 4,
            },
        })
        .then((response) => {
            return response.data;
        });
}

// stop and start alert
export async function startAndStopAlertAPI(value) {
    return await axios
        .post(baseUrl + '/master/startAndStopAlert', value)
        .then((response) => handleAPIResponse(response));
}

// export async function addMasterAPI(value) {
//     return await axios.post(baseUrl + '/master/import/file', value).then((response) => handleAPIResponse(response));
// }

export async function addMasterAPI(value) {
    return await axios.post(MBaseUrl + '/master-upload', value).then((response) => {
        return response.data;
    });
}
export async function exportMasterAPI(params) {
    return axios.get(baseUrl + '/master/export/file', {
        params,
        responseType: 'blob',
    });
}

export async function getUserRequestAPI(id) {
    return await axios.post(baseUrl + '/report/request/' + id).then((response) => handleAPIResponse(response));
}

export async function getAlertSummary(value) {
    return await axios.post(baseUrl + '/vc_alert_summary', value).then((response) => handleAPIResponse(response));
}

export async function getAlertLive(value) {
    return await axios.post(baseUrl + '/vc_alert_live', value).then((response) => handleAPIResponse(response));
}

export async function getAlertDetails(value) {
    return await axios.post(baseUrl + '/vc_alert_detail', value).then((response) => handleAPIResponse(response));
}

export async function getMaintenanceMode(value) {
    return await axios.post(baseUrl + '/maintenance_mode', value).then((response) => handleAPIResponse(response));
}
export async function getTelemetryLive(value) {
    return await axios.post(baseUrl + '/vc_telemetry_live', value).then((response) => handleAPIResponse(response));
}
export async function getTelemetryHistory(value) {
    return await axios.post(baseUrl + '/vc_telemetry_history', value).then((response) => handleAPIResponse(response));
}

export async function getRDPMSHealthLive(value) {
    return await axios.post(baseUrl + '/rdpms_health_live', value).then((response) => handleAPIResponse(response));
}

export async function getRDPMShealthSummary(value) {
    return await axios.post(baseUrl + '/rdpms_health_summary', value).then((response) => handleAPIResponse(response));
}

export async function getEquipmentRoomLive(value) {
    return await axios.post(baseUrl + '/equipment_room_live', value).then((response) => handleAPIResponse(response));
}

export async function getEquipmentRoomSummary(value) {
    return await axios.post(baseUrl + '/equipment_room_summary', value).then((response) => handleAPIResponse(response));
}

export async function getAssets(value) {
    return await axios.post(baseUrl + '/vc_asset', value).then((response) => handleAPIResponse(response));
}

export async function getAssetUtilization(value) {
    return await axios.post(baseUrl + '/asset_utilization', value).then((response) => handleAPIResponse(response));
}

export async function getPerformance(value) {
    return await axios.post(baseUrl + '/vc_performance', value).then((response) => handleAPIResponse(response));
}

// add all master
// add relay
export async function getMasterRelayAPI(value) {
    return await axios.post(baseUrl + '/master/relay', value).then((response) => handleAPIResponse(response));
}

export async function addRelayAPI(value) {
    return await axios.post(baseUrl + '/master/relay/create', value).then((response) => handleAPIResponse(response));
}

export async function editRelayAPI(value) {
    return await axios
        .post(baseUrl + '/master/relay/update/' + value.id, value)
        .then((response) => handleAPIResponse(response));
}

export async function deleteRelayAPI(id) {
    return await axios.post(baseUrl + '/master/relay/delete/' + id).then((response) => handleAPIResponse(response));
}

export async function getDashboardRelayAPI(value) {
    return await axios.post(baseUrl + '/dashboard/relay', value).then((response) => handleAPIResponse(response));
}

export async function getRelayAPI(value) {
    return await axios.post(baseUrl + '/relay', value).then((response) => handleAPIResponse(response));
}

export async function getRelayExportData(value) {
    return await axios.post(baseUrl + '/relay/export', value).then((response) => handleAPIResponse(response));
}

export async function getRelayArchieveAPI(value) {
    return await axios.post(baseUrl + '/archieve/relay', value).then((response) => handleAPIResponse(response));
}

export async function getRelayCurrentsGraphAPI(value) {
    return await axios.post(baseUrl + '/relay/relaycurrent', value).then((response) => handleAPIResponse(response));
}

export async function getRelayVoltagesGraphAPI(value) {
    return await axios.post(baseUrl + '/relay/relayvoltage', value).then((response) => handleAPIResponse(response));
}

export async function getPowerSupplyVoltageGraphAPI(value) {
    return await axios
        .post(baseUrl + '/relay/powersupplyvoltage', value)
        .then((response) => handleAPIResponse(response));
}

export async function getPowerSupplyCurrentGraphAPI(value) {
    return await axios
        .post(baseUrl + '/relay/powersupplycurrent', value)
        .then((response) => handleAPIResponse(response));
}

export async function getRelayArchieveAlertAPI(value) {
    return await axios.post(baseUrl + '/archieve/relay/alert', value).then((response) => handleAPIResponse(response));
}
